<template>
  <ReflectionCard class="mt-10">
    <template #header>
      <span>So what?</span>
    </template>
    <template #content>
      <div class="text-dark-grey text-xxs">
        <p>
          Consider the significance of what happened as well as the values and feelings at the time
          of and prompted by the experience, and why these may influence future learning or actions.
        </p>
        <br />
        <p class="mb-3">
          eg. 'How did I feel at the time of and after the experience, why was it important?'
        </p>
      </div>
      <textarea
        ref="soWhatRef"
        rows="4"
        v-model="so_what_field"
        @input="onInput"
        class="w-full border border-gray-200 rounded text-sm resize-none overflow-hidden"
        style="min-height: 6rem"
      ></textarea>
    </template>
  </ReflectionCard>
</template>

<script>
import ReflectionCard from './Components/ReflectionCard.vue';

export default {
  name: 'SoWhatCard',
  components: { ReflectionCard },
  props: {
    initialValue: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.soWhatRef;
      if (!el) return;

      const observer = new ResizeObserver(() => {
        if (el.offsetParent !== null) {
          this.autoResize();
          observer.disconnect();
        }
      });
      observer.observe(el);
    });
  },
  data() {
    return {
      so_what_field: this.initialValue ?? this.$page.props.session.reflection?.so_what,
    };
  },
  watch: {
    so_what_field: {
      immediate: true,
      handler() {
        if (this.$refs.soWhatRef?.offsetParent !== null) {
          this.$nextTick(this.autoResize);
        }
      },
    },
  },
  methods: {
    emitFieldChange() {
      this.$emit('fieldChanged', {
        field: 'so_what',
        value: this.so_what_field,
      });
    },
    onInput() {
      this.autoResize();
      this.emitFieldChange();
    },
    autoResize() {
      const el = this.$refs.soWhatRef;
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    },
  },
};
</script>

<style scoped></style>
